import { render } from "./SignUpPage.vue?vue&type=template&id=92738a94&scoped=true"
const script = {}

import "./SignUpPage.vue?vue&type=style&index=0&id=92738a94&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92738a94"]])

export default __exports__